import React, { Component } from 'react';
import { OptionWrapper, OptionTitle, SeparatorRow, CompartirTitle, ShareOptionsWrapper } from '../CompartirElement';
import { getTranslatedKey } from '../../../Utils/TranslateUtils';
import { crearUrlParametritzada } from '../CompartirUtils';
import { toast } from 'react-toastify';
import { visorVariables } from '../../../Utils/VisorsUtils';

const defaultShareText = 'Aquí tens la meva configuració del visor Hipermapa: ';

export default class ShareComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  //generar url
  generateUrl = () => {
    return crearUrlParametritzada(this.props.map, this.props.arrayLayers, this.props.fonsActiu, this.props.transparenciaFons);
  };

  //copiar iframe en portapapeles
  copyFrame = () => {
    let id = visorVariables.name + 'frame';
    let url = this.generateUrl();
    let iframe = `<iframe id='${id}' title='${visorVariables.name}' width='100%' height='100%' allowfullscreen src=${url}></iframe>`;
    navigator.clipboard
      .writeText(iframe)
      .then(() => {
        toast.success(getTranslatedKey('iframeSuccess'), { pauseOnHover: true });
      })
      .catch((err) => {
        toast.error(getTranslatedKey('clipboardError'), { autoClose: 4000, pauseOnHover: true });
      });
  };

  //copiar url generada en portapapeles
  copyUrl = () => {
    navigator.clipboard
      .writeText(this.generateUrl())
      .then(() => {
        toast.success(getTranslatedKey('urlSuccess'), { pauseOnHover: true });
      })
      .catch((err) => {
        toast.error(getTranslatedKey('clipboardError'), { autoClose: 4000, pauseOnHover: true });
      });
  };

  //compartir url generada por mail
  sendEmail = () => {
    let url = this.generateUrl();
    window.open("mailto:email@example.com?subject=Captura de l'Hipermapa&body=" + defaultShareText + encodeURIComponent(url));
  };

  //compartir url generada por whatsapp
  shareWhatsapp = () => {
    let url = this.generateUrl();
    let host = 'web';
    //diferenciamos entre movil y ordenador
    host = window.innerWidth <= 768 ? 'api' : 'web';
    window.open('https://' + host + '.whatsapp.com/send?text=' + defaultShareText + encodeURIComponent(url));
    window.open('https://' + host + '.whatsapp.com/send?text=' + defaultShareText + encodeURIComponent(url));
  };

  //compartir url generada por twitter
  shareTwitter = () => {
    let url = this.generateUrl();
    window.open('https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + defaultShareText);
  };

  //compartir url generada por linkedin
  shareLinkedin = () => {
    let url = this.generateUrl();
    window.open('http://www.linkedin.com/shareArticle?url=' + encodeURIComponent(url) + '&title=' + defaultShareText);
  };

  render() {
    return (
      <>
        <CompartirTitle>{getTranslatedKey('copyTitle')}</CompartirTitle>
        <ShareOptionsWrapper>
          <OptionWrapper onClick={() => this.copyUrl()} className="copy-url">
            <svg version="1.1" id="Capa_1" x="0px" y="0px" width="24" height="24" viewBox="0 0 283.5 283.5" fill="white">
              <g>
                <g>
                  <g>
                    <path d="M198.6,2.8H47c-14,0-25.3,11.3-25.3,25.3v176.8H47V28.1h151.6V2.8z" />
                    <path d="M236.5,53.3H97.5c-14,0-25.3,11.3-25.3,25.3v176.8c0,14,11.3,25.3,25.3,25.3h138.9c14,0,25.3-11.3,25.3-25.3V78.6     C261.7,64.6,250.4,53.3,236.5,53.3z M236.5,255.4H97.5V78.6h138.9V255.4z" />
                  </g>
                </g>
              </g>
            </svg>
            <OptionTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('compartirCopiar')}</OptionTitle>
          </OptionWrapper>
          <OptionWrapper onClick={() => this.copyFrame()} className="copy-frame">
            <svg version="1.1" id="Capa_1" x="0px" y="0px" width="24" height="24" viewBox="0 0 512 512" fill="white">
              <g>
                <path d="M27.6,271.1l85.3,85.3c8.2,8.5,21.7,8.7,30.2,0.5c8.5-8.2,8.7-21.7,0.5-30.2c-0.2-0.2-0.3-0.4-0.5-0.5L72.8,256l70.3-70.3   c8.5-8.2,8.7-21.7,0.5-30.2s-21.7-8.7-30.2-0.5c-0.2,0.2-0.4,0.3-0.5,0.5l-85.3,85.3C19.3,249.2,19.3,262.8,27.6,271.1L27.6,271.1z   " />
                <path d="M399.1,155.6c-8.2-8.5-21.7-8.7-30.2-0.5c-8.5,8.2-8.7,21.7-0.5,30.2c0.2,0.2,0.3,0.4,0.5,0.5l70.3,70.3l-70.3,70.3   c-8.5,8.2-8.7,21.7-0.5,30.2c8.2,8.5,21.7,8.7,30.2,0.5c0.2-0.2,0.4-0.3,0.5-0.5l85.3-85.3c8.3-8.3,8.3-21.8,0-30.2L399.1,155.6z" />
                <path d="M278.2,100.8l-85.3,298.7c-3.2,11.3,3.3,23.1,14.6,26.4c1.9,0.5,3.9,0.8,5.9,0.8c9.5,0,17.9-6.3,20.5-15.5l85.3-298.7   c3.7-11.2-2.5-23.2-13.7-26.9c-11.2-3.7-23.2,2.5-26.9,13.7C278.4,99.8,278.3,100.3,278.2,100.8L278.2,100.8z" />
              </g>
            </svg>
            <OptionTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('compartirIncrustar')}</OptionTitle>
          </OptionWrapper>
        </ShareOptionsWrapper>
        <SeparatorRow />
        <CompartirTitle>{getTranslatedKey('shareSocialTitle')}</CompartirTitle>
        <ShareOptionsWrapper>
          <OptionWrapper onClick={() => this.sendEmail()} className="send-email">
            <svg version="1.1" id="Layer_1" width="24" height="24" viewBox="0 0 283.5 283.5" fill="white">
              <path d="M256.2,59.5H64.6c-13.6,0-24.7,11.1-24.7,24.7v9.3c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2v-9.3c0-1.2,0.3-2.5,0.6-3.7  l69.2,59.3l-69.2,59.3c-0.3-1.2-0.6-2.5-0.6-3.7v-9.3c0-3.4-2.8-6.2-6.2-6.2c-3.4,0-6.2,2.8-6.2,6.2v9.3c0,13.6,11.1,24.7,24.7,24.7  h191.6c13.6,0,24.7-11.1,24.7-24.7V84.2C280.9,70.6,269.8,59.5,256.2,59.5z M62.1,72.2c0.6-0.3,1.5-0.3,2.5-0.3h191.6  c0.9,0,1.9,0,2.5,0.3l-94.3,80.7c-2.5,1.9-5.6,1.9-8,0L62.1,72.2z M256.2,207.8H64.6c-0.9,0-1.9,0-2.5-0.3l69.5-59.6l16.7,14.5  c3.4,3.1,7.7,4.6,12.1,4.6c4.3,0,8.7-1.5,12.1-4.6l16.7-14.5l69.5,59.6C258,207.8,257.1,207.8,256.2,207.8z M268.6,195.5  c0,1.2-0.3,2.5-0.6,3.7l-69.2-59.3l69.2-59.3c0.3,1.2,0.6,2.5,0.6,3.7V195.5z M21.3,124.4c0-3.4,2.8-6.2,6.2-6.2h37.1  c3.4,0,6.2,2.8,6.2,6.2c0,3.4-2.8,6.2-6.2,6.2H27.5C24.1,130.6,21.3,127.8,21.3,124.4z M64.6,161.5H9c-3.4,0-6.2-2.8-6.2-6.2  c0-3.4,2.8-6.2,6.2-6.2h55.6c3.4,0,6.2,2.8,6.2,6.2C70.8,158.7,68,161.5,64.6,161.5z" />
            </svg>
            <OptionTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('compartirEmail')}</OptionTitle>
          </OptionWrapper>
          <OptionWrapper onClick={() => this.shareWhatsapp()} className="share-whatsapp">
            <svg version="1.1" id="Capa_1" x="0px" y="0px" width="24" height="24" viewBox="0 0 283.5 283.5">
              <g id="Layer_2">
                <g id="whatsapp">
                  <path
                    id="background"
                    class="st0"
                    fill="#29A71A"
                    d="M39.7,1.4h204.1c21.1,0,38.3,17.1,38.3,38.3v204.1c0,21.1-17.1,38.3-38.3,38.3H39.7    c-21.1,0-38.3-17.1-38.3-38.3V39.7C1.4,18.6,18.6,1.4,39.7,1.4z"
                  />
                  <g id="icon">
                    <path
                      class="st1"
                      fill="#FFFFFF"
                      d="M203.6,79.9c-33.8-34.1-88.9-34.4-123.1-0.6c-26.9,26.6-33.5,67.6-16.3,101.3L55,225.3     c-0.2,0.9,0,1.8,0.5,2.6c0.8,1.2,2.2,1.7,3.6,1.4l43.9-10.4c43,21.4,95.2,3.8,116.6-39.2C236.2,146.4,229.7,106.3,203.6,79.9     L203.6,79.9z M189.9,189.2c-20.7,20.7-52.3,25.8-78.5,12.8l-6.1-3l-26.9,6.4l0.1-0.3l5.6-27.1l-3-5.9     c-13.4-26.3-8.3-58.2,12.5-79.1c26.6-26.6,69.7-26.6,96.3,0c0.1,0.1,0.2,0.2,0.4,0.4C216.5,119.9,216.4,162.7,189.9,189.2z"
                    />
                    <path
                      class="st1"
                      fill="#FFFFFF"
                      d="M187.5,169.3c-3.3,5.2-8.5,11.6-15.1,13.1c-11.5,2.8-29.1,0.1-51-20.3l-0.3-0.2     c-19.3-17.9-24.3-32.8-23.1-44.6c0.7-6.7,6.3-12.8,11-16.7c2.6-2.2,6.6-1.9,8.8,0.7c0.4,0.5,0.7,1,1,1.5l7.1,15.9     c0.9,2.1,0.6,4.6-0.8,6.4l-3.6,4.7c-1.6,2-1.8,4.7-0.6,6.9c2,3.5,6.8,8.7,12.2,13.5c6,5.4,12.6,10.4,16.9,12.1     c2.3,0.9,4.9,0.4,6.7-1.4l4.2-4.2c1.6-1.6,4-2.2,6.2-1.6l16.9,4.8c3.4,1,5.3,4.6,4.2,8C188,168.4,187.8,168.8,187.5,169.3     L187.5,169.3z"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <OptionTitle fontSizeEnabled={this.props.fontSizeEnabled}>Whatsapp</OptionTitle>
          </OptionWrapper>
          <OptionWrapper onClick={() => this.shareTwitter()} className="share-twitter">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" viewBox="0 0 1200 1227" fill="white">
              <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
            </svg>
            <OptionTitle fontSizeEnabled={this.props.fontSizeEnabled}>X</OptionTitle>
          </OptionWrapper>
          <OptionWrapper onClick={() => this.shareLinkedin()} className="share-linkedin">
            <svg version="1.1" id="Capa_1" x="0px" y="0px" width="24" height="24" viewBox="0 0 283.5 283.5">
              <g id="Layer_2">
                <g id="linkedin">
                  <path
                    id="background"
                    class="st0"
                    fill="#0077B5"
                    d="M39.7,1.4h204.1c21.1,0,38.3,17.1,38.3,38.3v204.1c0,21.1-17.1,38.3-38.3,38.3H39.7    c-21.1,0-38.3-17.1-38.3-38.3V39.7C1.4,18.6,18.6,1.4,39.7,1.4z"
                  />
                  <g id="icon">
                    <path
                      class="st1"
                      fill="#FFFFFF"
                      d="M102.5,78c0,13.2-10.7,23.9-23.9,23.9S54.7,91.2,54.7,78S65.4,54,78.6,54S102.5,64.7,102.5,78z"
                    />
                    <path
                      class="st1"
                      fill="#FFFFFF"
                      d="M97.1,117.8v105.7c0,3.3-2.6,5.9-5.9,5.9c0,0,0,0,0,0H66c-3.3,0-5.9-2.6-5.9-5.9c0,0,0,0,0,0V117.8     c0-3.3,2.7-5.9,5.9-5.9c0,0,0,0,0,0h25.2C94.4,111.9,97.1,114.5,97.1,117.8L97.1,117.8z"
                    />
                    <path
                      class="st1"
                      fill="#FFFFFF"
                      d="M228.9,172.8V224c0,3-2.4,5.4-5.4,5.5c0,0,0,0,0,0h-27.1c-3,0-5.4-2.4-5.5-5.4c0,0,0,0,0,0v-49.6     c0-7.4,2.2-32.4-19.3-32.4c-16.7,0-20.1,17.1-20.7,24.8V224c0,3-2.4,5.4-5.4,5.5h-26.2c-3,0-5.4-2.4-5.4-5.4c0,0,0,0,0,0V117.4     c0-3,2.4-5.4,5.4-5.5c0,0,0,0,0,0h26.2c3,0,5.5,2.4,5.5,5.5v9.2c6.2-9.3,15.4-16.4,34.9-16.4     C229.1,110.1,228.9,150.6,228.9,172.8L228.9,172.8z"
                    />
                  </g>
                </g>
              </g>
            </svg>
            <OptionTitle fontSizeEnabled={this.props.fontSizeEnabled}>LinkedIn</OptionTitle>
          </OptionWrapper>
        </ShareOptionsWrapper>
      </>
    );
  }
}
